<template>
  <b-modal
    v-model="modal"
    :title="title"
    size="md"
    :no-enforce-focus="true"
    :no-close-on-backdrop="true"
  >
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label for="type">Tipo</label>
          <select
            class="custom-select"
            name="type"
            id="type"
            v-model="form.type"
            :class="{
              'is-invalid': submitted && $v.form.type.$error,
            }"
          >
            <option v-for="(type, i) in attachmentType" :key="i" :value="i">{{ type }}</option>
          </select>
          <div
            v-if="submitted && !$v.form.type.required"
            class="invalid-feedback"
          >
          O campo é obrigatório
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label for="obs">Observação</label>
          <textarea
            id="obs"
            v-model="form.obs"
            name="obs"
            class="form-control"
          />
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveAttachment()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading
  },
  data () {
    return {
      title: 'Editar Anexo',
      loading: true,
      fullPage: true,
      submitted: false,
      form: {
        type: '',
        obs: '',
        participant_id: ''
      },
      modal: false
    }
  },
  validations: {
    form: {
      type: { required }
    }
  },
  computed: {
    ...mapGetters('settings', { attachmentType: 'ATTACHMENTTYPE' })
  },
  methods: {
    ...mapActions('participant', {
      editDataAttachment: 'updateAttachment'
    }),
    open (attachment) {
      if (!attachment) {
        return false
      }
      this.form = attachment
      this.modal = true
      this.loading = false
    },
    setDocument (e) {
      this.form.document = 1
    },
    async saveAttachment () {
      this.submitted = true
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        return
      }

      this.loading = true
      await this.editDataAttachment(this.form).then(res => {
        let message = 'Sucesso: Anexo atualizado com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('createdAttachment')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.submitted = false
      this.modal = false
      this.form = {}
      this.$v.$reset()
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>

</style>
